import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e79434c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "oxd-navbar-nav",
  role: "navigation",
  "aria-label": "Sidepanel"
}
const _hoisted_2 = { class: "oxd-sidepanel-header" }
const _hoisted_3 = { class: "oxd-sidepanel-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_branding = _resolveComponent("oxd-branding")!
  const _component_oxd_icon = _resolveComponent("oxd-icon")!
  const _component_oxd_main_menu = _resolveComponent("oxd-main-menu")!

  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(["oxd-sidepanel", _ctx.classes])
  }, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_oxd_branding, {
          toggle: _ctx.toggle,
          "logo-src": _ctx.brandLogoSrc,
          "banner-src": _ctx.brandBannerSrc,
          url: _ctx.homeUrl
        }, null, 8, ["toggle", "logo-src", "banner-src", "url"]),
        _createVNode(_component_oxd_icon, {
          name: "x",
          class: "oxd-sidepanel-header-close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('collapse')))
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_oxd_main_menu, {
          onCollapse: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('collapse'))),
          toggle: _ctx.toggle,
          "menu-items": _ctx.menuItems
        }, null, 8, ["toggle", "menu-items"])
      ])
    ])
  ], 2))
}